import {
  home_feiraoNormal,
  home_feiraoLarge,
  home_feiraoMobile,
} from 'assets/temporary/feirao/banners'

import {
  home_mobile,
  home_normal,
  home_large,
} from 'assets/temporary/blackout/banners'

import {
  blackoutDay_home_mobile,
  blackoutDay_home_normal,
  blackoutDay_home_large,
} from 'assets/temporary/blackout/BlackoutDay/banners'

import { SALE_CAMPAIGNS, isAnActiveCampaign } from 'utils/checkCampaign'

const imageList = []

if (isAnActiveCampaign(SALE_CAMPAIGNS.feirao)) {
  const feiraoBanner = {
    hasCounter: false,
    sourceMobile: home_feiraoMobile,
    sourceNormal: home_feiraoNormal,
    sourceLarge: home_feiraoLarge,
    link: `https://resale.com.br/busca?campanha-exclusiva=feirao`,
  }

  imageList.unshift(feiraoBanner)
}

if (isAnActiveCampaign(SALE_CAMPAIGNS.blackout)) {
  const blackoutBanner = {
    hasCounter: false,
    sourceMobile: home_mobile,
    sourceNormal: home_normal,
    sourceLarge: home_large,
    link: `busca?campanha-exclusiva=blackout`,
  }

  imageList.unshift(blackoutBanner)
}

if (isAnActiveCampaign(SALE_CAMPAIGNS.blackoutDay)) {
  const blackoutDayBanner = {
    hasCounter: false,
    sourceMobile: blackoutDay_home_mobile,
    sourceNormal: blackoutDay_home_normal,
    sourceLarge: blackoutDay_home_large,
    link: `busca?campanha-exclusiva=blackoutday`,
  }

  imageList.unshift(blackoutDayBanner)
}

export default imageList
